module.exports = __webpack_public_path__ + "static/media/move-right.856f0eb8.png";